<script setup lang="ts">
import { cn } from "@/lib/utils"
import { ComboboxGroup, type ComboboxGroupProps } from "reka-ui"
import { computed, type HTMLAttributes } from "vue"

const props = defineProps<ComboboxGroupProps & { class?: HTMLAttributes["class"]; heading?: string }>()

const delegatedProps = computed(() => {
  const { class: _, heading: _heading, ...delegated } = props
  return delegated
})
</script>

<template>
  <ComboboxGroup
    v-bind="delegatedProps"
    :class="
      cn(
        'overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground',
        props.class
      )
    "
  >
    <div v-if="heading" cmdk-group-heading class="text-xs font-medium text-muted-foreground px-2 py-1.5">
      {{ heading }}
    </div>
    <slot />
  </ComboboxGroup>
</template>
